import React, { useState, useEffect } from 'react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { employeeService } from '../services/employeeService';
import { companyService } from '../services/companyService';
import './Employees.css';

const Employees = () => {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [temporaryPassword, setTemporaryPassword] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCompany, setSelectedCompany] = useState(''); // Nouvel état pour la sélection d'entreprise
  const [companies, setCompanies] = useState([]); // Liste des entreprises disponibles
  const [newEmployee, setNewEmployee] = useState({
  employeeId: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  companyId: '', // AJOUTE CE LIGNE
  role: 'employee',
  language: 'fr',
  isActive: true, // AJOUTE CE CHAMP
  admin: false,   // AJOUTE CE CHAMP
  isPartner: false // AJOUTE CE CHAMP (optionnel)
});
  // Charger les employés et extraire les entreprises
  const fetchEmployees = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await employeeService.getEmployees();
      setEmployees(data.employees || []);
      setFilteredEmployees(data.employees || []);
      
       try {
      const companiesData = await companyService.getCompanies();
      // Adapte selon la structure de ta réponse API
      const companiesList = companiesData.companies || companiesData || [];
      
      // Formater pour l'affichage dans le select
      const formattedCompanies = companiesList.map(company => ({
        code: company._id || company.code, // Utilise l'ID ou le code de l'entreprise
        name: company.name || company.companyName || company.code,
        count: 0 // Sera calculé plus tard
      }));
      
      // Compter le nombre d'employés par entreprise
      const companiesWithCount = formattedCompanies.map(company => {
        const count = (data.employees || []).filter(emp => 
          emp.companyId === company.code || // selon ton modèle d'employé
          (emp.employeeId && emp.employeeId.startsWith(`${company.code}/`))
        ).length;
        return { ...company, count };
      });
      
      setCompanies(companiesWithCount);
    } catch (companyErr) {
      console.error('Erreur chargement entreprises:', companyErr);
      // Fallback : extraire des IDs comme avant
      const fallbackCompanies = extractCompaniesFromEmployees(data.employees || []);
      setCompanies(fallbackCompanies);
    }
    
  } catch (err) {
    setError(err.message || 'Erreur lors du chargement des employés');
    console.error('Erreur fetch employees:', err);
  } finally {
    setLoading(false);
  }
};
  // Fonction pour extraire les entreprises des employés
const extractCompaniesFromEmployees = (employeesList) => {
  const companiesSet = new Set();
  
  employeesList.forEach(employee => {
    // 1. D'abord vérifier si l'employé a un companyId
    if (employee.companyId) {
      companiesSet.add({
        code: employee.companyId,
        name: employee.companyName || `Entreprise ${employee.companyId}`,
        count: 0
      });
    }
  });
  
  // Compter le nombre d'employés par entreprise
  const companiesArray = Array.from(companiesSet).map(company => {
    const count = employeesList.filter(emp => {
      if (emp.companyId && emp.companyId === company.code) return true;
      if (emp.employeeId && emp.employeeId.startsWith(`${company.code}/`)) return true;
      return false;
    }).length;
    return { ...company, count };
  });
  
  // Trier par nom d'entreprise
  return companiesArray.sort((a, b) => a.name.localeCompare(b.name));
};
  useEffect(() => {
    fetchEmployees();
  }, []);

  // Filtrer les employés selon la recherche ET l'entreprise sélectionnée
// Filtrer les employés selon la recherche ET l'entreprise sélectionnée
useEffect(() => {
  let filtered = employees;
  
  // Filtrer par recherche
  if (searchTerm.trim() !== '') {
    filtered = filtered.filter(employee =>
      employee.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.employeeId?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  
  // Filtrer par entreprise sélectionnée
  if (selectedCompany) {
    filtered = filtered.filter(employee => 
      employee.companyId === selectedCompany || // 🔥 Nouveau critère
      (employee.employeeId && employee.employeeId.startsWith(`${selectedCompany}/`)) // Ancien critère
    );
  }
  
  setFilteredEmployees(filtered);
}, [searchTerm, selectedCompany, employees]);

  // Ajouter un employé
  const handleAddEmployee = async (e) => {
    e.preventDefault();
    try {
      setError('');
      const data = await employeeService.createEmployee(newEmployee);
      
      // Ajoute le nouvel employé à la liste
      setEmployees(prev => [data, ...prev]);
      
      // Mettre à jour la liste des entreprises si nécessaire
      if (data.employeeId) {
        const companyCode = data.employeeId.split('/')[0];
        const existingCompany = companies.find(c => c.code === companyCode);
        if (!existingCompany) {
          // Ajouter la nouvelle entreprise à la liste
          const newCompanies = [...companies, {
            code: companyCode,
            name: companyCode, // Par défaut
            count: 1
          }];
          setCompanies(newCompanies);
        } else {
          // Incrémenter le compteur
          const updatedCompanies = companies.map(c => 
            c.code === companyCode ? { ...c, count: c.count + 1 } : c
          );
          setCompanies(updatedCompanies);
        }
      }
      
      // Affiche le mot de passe dans un modal
      if (data.temporaryPassword) {
        setTemporaryPassword(data.temporaryPassword);
        setShowPasswordModal(true);
      }
      
      setNewEmployee({
        employeeId: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        role: 'employee',
        language: 'fr',
        companyId: '', // AJOUTE CE LIGNE ICI AUSSI
        isActive: true,
        admin: false,
        isPartner: false
      });
      setShowAddForm(false);
    } catch (err) {
      setError(err.message || 'Erreur lors de la création');
      console.error('Erreur create employee:', err);
    }
  };

  // Réinitialiser le mot de passe
  const handleResetPassword = async (employeeId) => {
    // Récupérer l'employé pour afficher son nom dans la confirmation
    const employee = employees.find(emp => emp._id === employeeId);
    
    if (!employee) return;
    
    if (!window.confirm(`Êtes-vous sûr de vouloir réinitialiser le mot de passe de ${employee.firstName} ${employee.lastName} ?\n\nUn nouveau mot de passe sera généré.`)) {
      return;
    }

    try {
      setError('');
      const result = await employeeService.resetPassword(employeeId);
      
      if (result.temporaryPassword) {
        setTemporaryPassword(result.temporaryPassword);
        setShowPasswordModal(true);
      }
    } catch (err) {
      setError(err.message || 'Erreur lors de la réinitialisation du mot de passe');
      console.error('Erreur reset password:', err);
    }
  };

  // Copier dans le presse-papier
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('Mot de passe copié dans le presse-papier !');
    }).catch(err => {
      console.error('Erreur lors de la copie:', err);
    });
  };

  // Ouvrir le formulaire de modification
  const handleEditEmployee = (employee) => {
    setEditingEmployee(employee);
    setShowEditForm(true);
  };

  // Modifier un employé
  const handleUpdateEmployee = async (e) => {
    e.preventDefault();
    try {
      setError('');
      const updatedEmployee = await employeeService.updateEmployee(
        editingEmployee._id, 
        editingEmployee
      );
      
      // Met à jour l'employé dans la liste
      setEmployees(prev => 
        prev.map(emp => 
          emp._id === editingEmployee._id ? updatedEmployee : emp
        )
      );
      
      setShowEditForm(false);
      setEditingEmployee(null);
    } catch (err) {
      setError(err.message || 'Erreur lors de la modification');
      console.error('Erreur update employee:', err);
    }
  };

  // Supprimer un employé
  const handleDeleteEmployee = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet employé ?')) {
      return;
    }

    try {
      setError('');
      await employeeService.deleteEmployee(id);
      const employeeToDelete = employees.find(emp => emp._id === id);
      
      // Mettre à jour la liste des employés
      const newEmployees = employees.filter(emp => emp._id !== id);
      setEmployees(newEmployees);
      
      // Mettre à jour le compteur d'entreprise si nécessaire
      if (employeeToDelete && employeeToDelete.employeeId) {
        const companyCode = employeeToDelete.employeeId.split('/')[0];
        const updatedCompanies = companies.map(c => 
          c.code === companyCode && c.count > 0 ? { ...c, count: c.count - 1 } : c
        ).filter(c => c.count > 0); // Supprimer les entreprises sans employés
        setCompanies(updatedCompanies);
      }
    } catch (err) {
      setError(err.message || 'Erreur lors de la suppression');
      console.error('Erreur delete employee:', err);
    }
  };

  const getRoleIcon = (role) => {
    switch(role) {
      case 'admin': return '👑';
      case 'manager': return '⭐';
      case 'employee': return '👤';
      default: return '👤';
    }
  };

  const getRoleLabel = (role) => {
    switch(role) {
      case 'admin': return 'Administrateur';
      case 'manager': return 'Manager';
      case 'employee': return 'Employé';
      default: return role;
    }
  };

  const getLanguageLabel = (language) => {
    switch(language) {
      case 'fr': return 'Français';
      case 'en': return 'English';
      case 'ar': return 'العربية';
      default: return language;
    }
  };

  // Fonction pour réinitialiser les filtres
  const handleClearFilters = () => {
    setSearchTerm('');
    setSelectedCompany('');
  };

  if (loading) {
    return (
      <div className="employees">
        <div className="page-header">
          <div className="page-title">
            <h1>Gestion des Employés</h1>
            <p>Chargement...</p>
          </div>
        </div>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Chargement des employés...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="employees">
      {/* En-tête de page */}
      <div className="page-header">
        <div className="page-title">
          <h1>Gestion des Employés</h1>
          <p>Gérez les employés de votre entreprise ({employees.length} employé{employees.length > 1 ? 's' : ''})</p>
        </div>
        <Button 
          variant="primary" 
          size="lg"
          onClick={() => setShowAddForm(true)}
        >
          <span className="button-icon">➕</span>
          Ajouter un employé
        </Button>
      </div>

      {/* Barre de recherche ET filtre par entreprise */}
      <Card className="filters-card" padding="md">
        <div className="filters-container">
          {/* Barre de recherche */}
          <div className="search-container">
            <div className="search-icon">🔍</div>
            <input
              type="text"
              placeholder="Rechercher un employé par nom, prénom, email ou ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            {searchTerm && (
              <button 
                className="clear-search"
                onClick={() => setSearchTerm('')}
              >
                ✕
              </button>
            )}
          </div>
          
          {/* Sélecteur d'entreprise */}
          {/* Sélecteur d'entreprise */}
          <div className="company-filter">
            <select
              value={selectedCompany}
              onChange={(e) => setSelectedCompany(e.target.value)}
              className="company-select"
            >
              <option value="">Toutes les entreprises</option>
              {companies.map(company => (
                <option key={company.code} value={company.code}>
                  {company.name} ({company.count}) {/* 🔥 Affiche le vrai nom */}
                </option>
              ))}
            </select>
          </div>
          
          {/* Bouton pour effacer les filtres */}
          {(searchTerm || selectedCompany) && (
            <Button 
              variant="secondary" 
              size="sm"
              onClick={handleClearFilters}
              className="clear-filters-btn"
            >
              Effacer les filtres
            </Button>
          )}
        </div>
        
        {/* Informations sur les filtres */}
        {(searchTerm || selectedCompany) && (
          <div className="filters-info">
            <span className="results-count">
              {filteredEmployees.length} employé{filteredEmployees.length > 1 ? 's' : ''} trouvé{filteredEmployees.length > 1 ? 's' : ''}
              {selectedCompany && (
                <span className="company-filter-info">
                  {' '}dans l'entreprise: {companies.find(c => c.code === selectedCompany)?.name}
                </span>
              )}
            </span>
          </div>
        )}
      </Card>

      {/* Message d'erreur */}
      {error && (
        <Card className="error-card" padding="md">
          <div className="error-message">
            <span>❌</span>
            {error}
            <button onClick={() => setError('')} className="error-close">✕</button>
          </div>
        </Card>
      )}

      {/* Modal d'affichage du mot de passe */}
      {showPasswordModal && (
        <div className="modal-overlay">
          <Card className="modal" padding="xl" borderRadius="xl">
            <div className="modal-header">
              <h2>Mot de passe généré</h2>
              <button 
                className="close-button"
                onClick={() => setShowPasswordModal(false)}
              >
                ✕
              </button>
            </div>
            
            <div className="password-modal-content">
              <div className="password-warning">
                <span>⚠️</span>
                <p>Ce mot de passe a été généré pour l'employé — prière de le lui communiquer.</p>
              </div>
              
              <div className="password-display">
                <label className="form-label">Mot de passe:</label>
                <div className="password-field">
                  <input
                    type="text"
                    value={temporaryPassword}
                    readOnly
                    className="form-input password-input"
                  />
                  <Button 
                    variant="secondary" 
                    size="sm"
                    onClick={() => copyToClipboard(temporaryPassword)}
                  >
                    📋 Copier
                  </Button>
                </div>
              </div>
              
              <div className="form-actions">
                <Button 
                  variant="primary"
                  onClick={() => setShowPasswordModal(false)}
                >
                  J'ai noté le mot de passe
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}

      {/* Modal d'ajout */}
      {showAddForm && (
        <div className="modal-overlay">
          <Card className="modal" padding="xl" borderRadius="xl">
            <div className="modal-header">
              <h2>Nouvel Employé</h2>
              <button 
                className="close-button"
                onClick={() => setShowAddForm(false)}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleAddEmployee} className="employee-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Prénom *</label>
                  <input
                    type="text"
                    value={newEmployee.firstName}
                    onChange={(e) => setNewEmployee({...newEmployee, firstName: e.target.value})}
                    required
                    className="form-input"
                    placeholder="Mohamed"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Nom *</label>
                  <input
                    type="text"
                    value={newEmployee.lastName}
                    onChange={(e) => setNewEmployee({...newEmployee, lastName: e.target.value})}
                    required
                    className="form-input"
                    placeholder="Bouras"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  value={newEmployee.email}
                  onChange={(e) => setNewEmployee({...newEmployee, email: e.target.value})}
                  required
                  className="form-input"
                  placeholder="mohamed.bouras@company.com"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Téléphone *</label>
                <input
                  type="tel"
                  value={newEmployee.phone}
                  onChange={(e) => setNewEmployee({...newEmployee, phone: e.target.value})}
                  required
                  className="form-input"
                  placeholder="+213 555 12 34 56"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Rôle *</label>
                  <select
                    value={newEmployee.role}
                    onChange={(e) => setNewEmployee({...newEmployee, role: e.target.value})}
                    className="form-select"
                    required
                  >
                    <option value="employee">👤 Employé</option>
                    <option value="manager">⭐ Manager</option>
                    <option value="admin">👑 Administrateur</option>
                    
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Langue *</label>
                  <select
                    value={newEmployee.language}
                    onChange={(e) => setNewEmployee({...newEmployee, language: e.target.value})}
                    className="form-select"
                    required
                  >
                    <option value="fr">🇫🇷 Français</option>
                    <option value="en">🇬🇧 English</option>
                    <option value="ar">🇩🇿 العربية</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Entreprise *</label>
                <select
                  value={newEmployee.companyId}
                  onChange={(e) => setNewEmployee({...newEmployee, companyId: e.target.value})}
                  className="form-select"
                  required
                >
                  <option value="">Sélectionner une entreprise...</option>
                  {companies.map(company => (
                    <option key={company.code} value={company.code}>
                      {company.name} ({company.count} employé{company.count > 1 ? 's' : ''})
                    </option>
                  ))}
                </select>
              </div>

                {/* 🔥 AJOUTE CE BLOC DANS LE FORMULAIRE D'AJOUT */}

{/* ✅ CORRECTION: Un seul `form-row` */}
              <div className="form-row">
                  <div className="form-group">
                      <label className="form-label">Statut</label>
                      <select
                          value={newEmployee.isActive.toString()}
                          onChange={(e) => setNewEmployee({...newEmployee, isActive: e.target.value === 'true'})}
                          className="form-select"
                      >
                          <option value="true">🟢 Actif</option>
                          <option value="false">🔴 Inactif</option>
                      </select>
                  </div>
              </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">isPartner</label>
                    <select
                      value={newEmployee.isPartner ? 'true' : 'false'}
                      onChange={(e) => setNewEmployee({...newEmployee, isPartner: e.target.value === 'true'})}
                      className="form-select"
                    >
                      <option value="false">Utilisateur normal</option>
                      <option value="true">👑 Partenaire</option>
                    </select>
                  </div>
                </div>


              <div className="form-actions">
                <Button 
                  type="button" 
                  variant="secondary"
                  onClick={() => setShowAddForm(false)}
                >
                  Annuler
                </Button>
                <Button type="submit" variant="primary">
                  Créer l'employé
                </Button>
              </div>
            </form>
          </Card>
        </div>
      )}

      {/* Modal de modification */}
      {showEditForm && editingEmployee && (
        <div className="modal-overlay">
          <Card className="modal" padding="xl" borderRadius="xl">
            <div className="modal-header">
              <h2>Modifier l'employé</h2>
              <button 
                className="close-button"
                onClick={() => {
                  setShowEditForm(false);
                  setEditingEmployee(null);
                }}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleUpdateEmployee} className="employee-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Prénom *</label>
                  <input
                    type="text"
                    value={editingEmployee.firstName}
                    onChange={(e) => setEditingEmployee({...editingEmployee, firstName: e.target.value})}
                    required
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Nom *</label>
                  <input
                    type="text"
                    value={editingEmployee.lastName}
                    onChange={(e) => setEditingEmployee({...editingEmployee, lastName: e.target.value})}
                    required
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  value={editingEmployee.email}
                  onChange={(e) => setEditingEmployee({...editingEmployee, email: e.target.value})}
                  required
                    className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Téléphone *</label>
                <input
                  type="tel"
                  value={editingEmployee.phone}
                  onChange={(e) => setEditingEmployee({...editingEmployee, phone: e.target.value})}
                  required
                    className="form-input"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Rôle *</label>
                  <select
                    value={editingEmployee.role}
                    onChange={(e) => setEditingEmployee({...editingEmployee, role: e.target.value})}
                    className="form-select"
                    required
                  >
                    <option value="employee">👤 Employé</option>
                    <option value="manager">⭐ Manager</option>
                    <option value="admin">👑 Administrateur</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Entreprise</label>
                  <select
                    value={editingEmployee.companyId || ''}
                    onChange={(e) => setEditingEmployee({...editingEmployee, companyId: e.target.value})}
                    className="form-select"
                  >
                    <option value="">Sélectionner une entreprise...</option>
                    {companies.map(company => (
                      <option key={company.code} value={company.code}>
                        {company.name} ({company.count} employé{company.count > 1 ? 's' : ''})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Langue *</label>
                  <select
                    value={editingEmployee.language}
                    onChange={(e) => setEditingEmployee({...editingEmployee, language: e.target.value})}
                    className="form-select"
                    required
                  >
                    <option value="fr">🇫🇷 Français</option>
                    <option value="en">🇬🇧 English</option>
                    <option value="ar">🇩🇿 العربية</option>
                  </select>
                </div>
              </div>




{/* 🔥 AJOUTE CE BLOC DANS LE FORMULAIRE DE MODIFICATION */}
<div className="form-row">
  <div className="form-group">
    <label className="form-label">isPartner</label>
    <select
      value={editingEmployee.isPartner ? 'true' : 'false'}
      onChange={(e) => setEditingEmployee({...editingEmployee, isPartner: e.target.value === 'true'})}
      className="form-select"
    >
      <option value="false"> Non</option>
      <option value="true">🤝 Oui</option>
    </select>
  </div>
</div>



              <div className="form-group">
                <label className="form-label">Statut</label>
                <select
                  value={editingEmployee.isActive ? 'active' : 'inactive'}
                  onChange={(e) => setEditingEmployee({...editingEmployee, isActive: e.target.value === 'active'})}
                  className="form-select"
                >
                  <option value="active">🟢 Actif</option>
                  <option value="inactive">🔴 Inactif</option>
                </select>
              </div>

              <div className="form-actions">
                <Button 
                  type="button" 
                  variant="secondary"
                  onClick={() => {
                    setShowEditForm(false);
                    setEditingEmployee(null);
                  }}
                >
                  Annuler
                </Button>
                <Button type="submit" variant="primary">
                  Modifier l'employé
                </Button>
              </div>
            </form>
          </Card>
        </div>
      )}

      {/* Grille des employés */}
      <div className="employees-grid">
        {filteredEmployees.map(employee => (
          <Card key={employee._id} className="employee-card" padding="lg">
            <div className="employee-header">
              <div className="employee-avatar">
                <span className="avatar-icon">{getRoleIcon(employee.role)}</span>
              </div>
              <div className="employee-info">
                <h3 className="employee-name">{employee.firstName} {employee.lastName}</h3>
                <span className={`role-badge ${employee.role}`}>
                  {getRoleIcon(employee.role)} {getRoleLabel(employee.role)}
                </span>
              </div>
            </div>
            
            <div className="employee-details">
              {/* Tous les spans directement dans .employee-details */}
              <span className="detail-label">Entreprise:</span>
              <span className="detail-value"> {companies.find(c => c.code === employee.companyId)?.name || employee.companyId || 'Non assigné'}</span>
              
              <span className="detail-label">ID:</span>
              <span className="detail-value">{employee.employeeId}</span>
              
              <span className="detail-label">Email:</span>
              <span className="detail-value">{employee.email}</span>
              
              <span className="detail-label">Téléphone:</span>
              <span className="detail-value">{employee.phone}</span>
              
              <span className="detail-label">Langue:</span>
              <span className="detail-value">{getLanguageLabel(employee.language)}</span>
              
              {employee.isPartner && (
                <>
                  <span className="detail-label">Type:</span>
                  <span className={`status-badge ${employee.isPartner ? 'partner' : 'company'}`}>
                    {employee.isPartner ? '🤝 Partenaire' : '🏢 Entreprise'}
                  </span>
                </>
              )}
              
              <span className="detail-label">Économies:</span>
              <span className="detail-value savings">{employee.totalSavings || 0}DA</span>
              
              <span className="detail-label">Statut:</span>
              <span className={`status-badge ${employee.isActive ? 'active' : 'inactive'}`}>
                {employee.isActive ? '🟢 Actif' : '🔴 Inactif'}
              </span>
            </div>
            
            <div className="employee-actions">
              <Button 
                variant="secondary" 
                size="sm"
                onClick={() => handleEditEmployee(employee)}
              >
                ✏️ Modifier
              </Button>
              
              <Button 
                variant="secondary" 
                size="sm"
                onClick={() => handleResetPassword(employee._id)}
              >
                🔄 Réinitialiser MDP
              </Button>
              
              <Button 
                variant="danger" 
                size="sm"
                onClick={() => handleDeleteEmployee(employee._id)}
                disabled={employee.admin === true || employee.isActive === true}
              >
                🗑️ Supprimer
              </Button>
            </div>
          </Card>
        ))}
      </div>

      {/* État vide */}
      {filteredEmployees.length === 0 && !loading && (
        <Card className="empty-state">
          <div className="empty-icon">👥</div>
          <h3 className="empty-title">
            {searchTerm || selectedCompany ? 'Aucun employé trouvé' : 'Aucun employé'}
          </h3>
          <p className="empty-text">
            {searchTerm 
              ? `Aucun résultat pour "${searchTerm}"`
              : selectedCompany
              ? `Aucun employé trouvé dans l'entreprise sélectionnée`
              : 'Commencez par ajouter votre premier employé'
            }
          </p>
          <Button 
            variant="primary"
            onClick={() => {
              handleClearFilters();
              setShowAddForm(true);
            }}
          >
            ➕ Ajouter un employé
          </Button>
        </Card>
      )}
    </div>
  );
};

export default Employees;